import { Checkbox, CheckboxChangeEvent } from '@progress/kendo-react-inputs';
import React from 'react';
import styled from 'styled-components';
import { FormSkeletonLoader } from '../FormSkeletonLoader';

type Props = {
  label?: string;
  className?: string;
  onChange?: (event: CheckboxChangeEvent) => void;
  checked?: boolean | null;
  value?: string | number | string[] | boolean | null;
  isDisabled?: boolean;
  isLoader?: boolean;
};

export const CheckBox = ({
  className,
  label,
  onChange,
  checked,
  value,
  isDisabled,
  isLoader,
}: Props) => {
  return (
    <StyledDiv className={className}>
      {!isLoader ? (
        <>
          <Checkbox
            onChange={onChange}
            checked={isDisabled ? false : checked}
            value={value}
            disabled={isDisabled}
          />
          <label>{label}</label>
        </>
      ) : (
        <FormSkeletonLoader textHeight={44} labelHeight={20} isLabel />
      )}
    </StyledDiv>
  );
};
const StyledDiv = styled.div`
  display: flex;
  /* gap: 10px; */
  align-items: center;
  margin: 6px 0;
  .k-checkbox {
    background-color: #2a2a2a !important;
  }
  .k-checkbox-wrap {
    padding-right: 10px !important;
  }

  .k-checkbox:focus {
    box-shadow: none !important;
    border-color: #808080 !important;
  }
  &:focus {
    outline-style: none;
    box-shadow: none;
    border-color: #707070;
  }

  input[type='checkbox'] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 16px;
    height: 16px;
    border: 1px solid #808080;
    border-radius: 4px;
    outline: none;
    transition: border-color 0.3s;
    cursor: pointer;
  }

  input[type='checkbox']:checked {
    background-color: #2dce98 !important;
  }

  input[type='checkbox']:checked::before {
    content: '';
    display: block;
    width: 9px;
    height: 5px;
    border: 2px solid white;
    border-top: none;
    border-right: none;
    transform: rotate(-45deg);
    margin: 3px;
  }
  label {
    font-size: 14px;
  }
  //Component Responsive
  @media (min-width: 100px) and (max-width: 319px) {
    label {
      font-size: 11px;
    }
  }
  @media (min-width: 320px) and (max-width: 575px) {
    label {
      font-size: 11px;
    }
  }
  @media (min-width: 576px) and (max-width: 767px) {
    label {
      font-size: 12px;
    }
  }
  @media (min-width: 768px) and (max-width: 991px) {
    label {
      font-size: 12px;
    }
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    label {
      font-size: 13px;
    }
  }
  @media (min-width: 1200px) and (max-width: 1365px) {
    label {
      font-size: 14px;
    }
  }
  @media (min-width: 1366px) and (max-width: 1448px) {
    label {
      font-size: 14px;
    }
  }
  @media (min-width: 1449px) and (max-width: 1719px) {
    font-size: 15px;
  }
  @media (min-width: 1720px) and (max-width: 4000px) {
    font-size: 16px;
  }
`;
